var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{attrs:{"id":"pdf-container"}},[_c('div',{style:({margin: 'auto'}),attrs:{"id":"pdf-wrapper","data-width":_vm.width,"data-height":_vm.height,"tabindex":"1"}},[_c('canvas',{attrs:{"id":"canvas"}}),(_vm.loading)?_c('Loading',{style:({background: 'transparent'})}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }